import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Product {
  id: string;
  order_id: string;
  barcode: string;
  name: string;
  boxes: number;
  units_per_box: number;
  cost_per_unit: number | null;
  cost_per_box: number | null;
  suggested_retail_price: number | null;
  retail_multiplier: number | null;
  photos: string[];
  has_credit: boolean;
  category_id: string | null;
  ai_suggested_category: string | null;
  square_item_id: string | null;
  square_variation_id: string | null;
  submit_status: string | null;
  creation_source: string | null;
  created_at: string;
  updated_at: string;
}

export const useProducts = (orderId: string) => {
  return useQuery({
    queryKey: ['products', orderId],
    queryFn: async (): Promise<Product[]> => {
      if (!orderId) return [];
      
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('order_id', orderId)
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data || [];
    },
    enabled: !!orderId,
  });
};